import React, { useEffect, useState } from 'react';
import { CardBody, Row, Col, Container } from 'reactstrap';
import { IoTimeOutline, IoChevronBack, IoChevronForward } from 'react-icons/io5';
import NoGo from '../asset/Img.png';
import DashboardService from '../../../../../api/dashboardService';
import ImageZoom from '../../../../Dashboards/AreaDashbaord/reports/Components/LiveAlertsCards/ImageZoom';

const HelmetModule = ({ filter, title }) => {
    const [alerts, setAlerts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedImage, setSelectedImage] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [currentAlert, setCurrentAlert] = useState(null);
    const [Filter, setFilter] = useState([]);
    const [showZoomModal, setShowZoomModal] = useState(false);
    const [zoomImageData, setZoomImageData] = useState({});

    // Get current week in YYYY-WXX format
    const getCurrentWeek = () => {
        const now = new Date();
        const year = now.getFullYear();
        const startOfYear = new Date(year, 0, 1);
        const days = Math.floor((now - startOfYear) / (24 * 60 * 60 * 1000));
        const weekNumber = Math.ceil((days + startOfYear.getDay() + 1) / 7);
        return `${year}-W${weekNumber.toString().padStart(2, '0')}`;
    };
    useEffect(() => {
        setFilter(filter)
    }, [])
    // Format timestamp to readable format
    const formatTime = (timestamp) => {
        const date = new Date(timestamp);
        const today = new Date();
        const isToday = date.toDateString() === today.toDateString();

        if (isToday) {
            return `Today, ${date.toLocaleTimeString('en-US', {
                hour12: false,
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            })}`;
        } else {
            return date.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        }
    };
    console.log("filters coming in child", filter)

    // Transform API data to component format
    const transformAlertData = (apiData) => {
        // Ensure apiData is an array
        if (!Array.isArray(apiData)) {
            console.warn('API data is not an array:', apiData);
            return [];
        }

        return apiData.map((alert, index) => ({
            id: alert.alert_id || index + 1,
            title: alert.module_name === "No_Go_Area" ? "Person in No-go Area" : alert.module_name || "N/A",
            area: alert.zone_name || "N/A",
            camera: alert.camera_id || "N/A",
            time: formatTime(alert.timestamp),
            type: alert.compliant ? "normal" : "critical",
            borderColor: alert.compliant ? "#10B981" : "#EF4444",
            badgeColor: alert.compliant ? "#10B981" : "#EF4444",
            badgeText: alert.compliant ? "normal" : "critical",
            annotated_url: alert.annotated_url,
            unannotated_url: alert.unannotated_url
        }));
    };

    // Fetch live alerts
    const fetchLiveAlerts = async () => {
        try {
            setLoading(true);
            const payload = {
                factory_id: 19,
                client_id: 20,
                filters: {
                    week: filter.week,
                    date: filter.date || "",
                    month: filter.month || "",
                    starting: filter.customStartDate || "",
                    ending: filter.customEndDate || ""
                },
                module_ids: [1],
                zone_ids: [],
                shift: [],
                severity: ""
            };

            const response = await DashboardService.getRecentAlerts(payload);
            console.log('API Response:', response.data); // Debug log

            if (response.data && response.data.success) {
                // Handle different possible response structures
                let alertsData = response.data.data;

                // If data is an object with an array property, extract it
                if (alertsData && typeof alertsData === 'object' && !Array.isArray(alertsData)) {
                    // Try common array property names
                    alertsData = alertsData.alerts || alertsData.items || alertsData.results || [];
                }

                // Ensure we have an array
                if (!Array.isArray(alertsData)) {
                    alertsData = [];
                }

                const transformedAlerts = transformAlertData(alertsData);
                setAlerts(transformedAlerts);

                // Set the first alert's image as default
                if (transformedAlerts.length > 0) {
                    setSelectedImage(transformedAlerts[0].annotated_url || transformedAlerts[0].unannotated_url);
                    setCurrentAlert(transformedAlerts[0]);
                    setCurrentImageIndex(0);
                }
            } else {
                console.warn('API response structure unexpected:', response.data);
                setAlerts([]);
            }
        } catch (error) {
            console.error('Error fetching live alerts:', error);
            // Fallback to static data on error
            const staticAlerts = [
                {
                    id: 1,
                    title: "Person in No-go Area",
                    area: "N/A",
                    camera: "N/A",
                    time: "N/A",
                    type: "critical",
                    borderColor: "#EF4444",
                    badgeColor: "#EF4444",
                    badgeText: "critical"
                }
            ];
            setAlerts(staticAlerts);
        } finally {
            setLoading(false);
        }
    };

    // Navigation functions
    const goToPrevious = () => {
        if (alerts.length > 1) {
            const prevIndex = currentImageIndex === 0 ? alerts.length - 1 : currentImageIndex - 1;
            const prevAlert = alerts[prevIndex];
            setSelectedImage(prevAlert.annotated_url || prevAlert.unannotated_url);
            setCurrentAlert(prevAlert);
            setCurrentImageIndex(prevIndex);
        }
    };

    const goToNext = () => {
        if (alerts.length > 1) {
            const nextIndex = (currentImageIndex + 1) % alerts.length;
            const nextAlert = alerts[nextIndex];
            setSelectedImage(nextAlert.annotated_url || nextAlert.unannotated_url);
            setCurrentAlert(nextAlert);
            setCurrentImageIndex(nextIndex);
        }
    };

    useEffect(() => {
        fetchLiveAlerts();
    }, []);

    // Handle alert click to change image
    const handleAlertClick = (alert, index) => {
        const imageUrl = alert.annotated_url || alert.unannotated_url;
        if (imageUrl) {
            setSelectedImage(imageUrl);
            setCurrentAlert(alert);
            setCurrentImageIndex(index);
        }
    };

    // Handle image click to open zoom modal
    const handleImageClick = () => {
        if (selectedImage && currentAlert) {
            setZoomImageData({
                cameraName: currentAlert.camera,
                violation: currentAlert.title,
                date: currentAlert.time,
                time: ''
            });
            setShowZoomModal(true);
        }
    };

    return (
        <>
            <style>
                {`
                    .alerts-scroll-container::-webkit-scrollbar {
                        width: 6px;
                    }
                    .alerts-scroll-container::-webkit-scrollbar-track {
                        background: #F7FAFC;
                        border-radius: 3px;
                    }
                    .alerts-scroll-container::-webkit-scrollbar-thumb {
                        background: #CBD5E0;
                        border-radius: 3px;
                    }
                    .alerts-scroll-container::-webkit-scrollbar-thumb:hover {
                        background: #A0AEC0;
                    }
                    .image-overlay {
                        position: absolute;
                        top: 16px;
                        left: 16px;
                        background: rgba(0, 0, 0, 0.8);
                        color: white;
                        padding: 8px 16px;
                        border-radius: 8px;
                        font-size: 14px;
                        font-weight: 600;
                        backdrop-filter: blur(4px);
                        z-index: 10;
                    }
                    .image-counter {
                        position: absolute;
                        top: 16px;
                        right: 16px;
                        background: rgba(0, 0, 0, 0.8);
                        color: white;
                        padding: 4px 12px;
                        border-radius: 16px;
                        font-size: 12px;
                        font-weight: 500;
                        backdrop-filter: blur(4px);
                        z-index: 10;
                    }
                    .alert-type-badge {
                        position: absolute;
                        bottom: 16px;
                        left: 16px;
                        padding: 6px 12px;
                        border-radius: 16px;
                        font-size: 12px;
                        font-weight: 600;
                        text-transform: uppercase;
                        z-index: 10;
                    }
                    .nav-arrow {
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        background: rgba(0, 0, 0, 0.7);
                        color: white;
                        border: none;
                        border-radius: 50%;
                        width: 40px;
                        height: 40px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        transition: all 0.2s ease;
                        z-index: 15;
                        backdrop-filter: blur(4px);
                    }
                    .nav-arrow:hover {
                        background: rgba(0, 0, 0, 0.9);
                        transform: translateY(-50%) scale(1.1);
                    }
                    .nav-arrow:disabled {
                        opacity: 0.3;
                        cursor: not-allowed;
                    }
                    .nav-arrow:disabled:hover {
                        transform: translateY(-50%) scale(1);
                        background: rgba(0, 0, 0, 0.7);
                    }
                    .nav-arrow-left {
                        left: 16px;
                    }
                    .nav-arrow-right {
                        right: 16px;
                    }
                    @media (max-width: 768px) {
                        .alerts-scroll-container {
                            height: 300px !important;
                        }
                        .alert-card {
                            height: 90px !important;
                            padding: 12px !important;
                        }
                        .alert-title {
                            font-size: 14px !important;
                        }
                        .alert-details {
                            font-size: 12px !important;
                        }
                        .image-container {
                            height: 300px !important;
                        }
                    }
                    @media (max-width: 576px) {
                        .alerts-scroll-container {
                            height: 250px !important;
                        }
                        .alert-card {
                            height: 80px !important;
                            padding: 10px !important;
                        }
                        .image-container {
                            height: 250px !important;
                        }
                        .alert-badge {
                            padding: 2px 6px !important;
                            font-size: 9px !important;
                        }
                        .alert-time {
                            font-size: 10px !important;
                        }
                    }
                `}
            </style>
            <Container fluid className="p-4 shadow" style={{ border: "1px solid #E4E4E7", backgroundColor: "#FFFFFF", borderRadius: "8px" }}>
                {/* Header */}
                <div className="d-flex justify-content-center align-items-center mb-4">
                    <h2 style={{
                        fontSize: "24px",
                        fontWeight: "700",
                        color: "#091954",
                        margin: "0",
                        textAlign: "center"
                    }}>
                        {title || 'No-go Areas Alerts'}
                    </h2>
                </div>

                <Row className="g-4">
                    {/* Left Side - Image */}
                    <Col xl={8} lg={7} md={12} sm={12}>
                        <div className="image-container" style={{
                            position: 'relative',
                            borderRadius: '12px',
                            overflow: 'hidden',
                            height: '355px',
                            minHeight: '300px',
                            backgroundColor: '#f3f4f6',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <img
                                src={selectedImage || NoGo}
                                alt="Construction site monitoring"
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    width: 'auto',
                                    height: 'auto',
                                    objectFit: 'contain',
                                    transition: 'opacity 0.5s ease-in-out',
                                    cursor: selectedImage ? 'pointer' : 'default'
                                }}
                                onClick={handleImageClick}
                                onError={(e) => {
                                    e.target.src = NoGo; // Fallback to default image on error
                                }}
                            />

                            {/* Zone Information Overlay */}
                            {currentAlert && !loading && (
                                <>
                                    <div className="image-overlay">
                                        {currentAlert.area}
                                    </div>

                                    <div className="image-counter">
                                        {currentImageIndex + 1} / {alerts.length}
                                    </div>
                                </>
                            )}

                            {/* Navigation Arrows - Only show when not loading and have multiple alerts */}
                            {!loading && alerts.length > 1 && (
                                <>
                                    <button
                                        className="nav-arrow nav-arrow-left"
                                        onClick={goToPrevious}
                                        title="Previous Image"
                                    >
                                        <IoChevronBack size={20} />
                                    </button>
                                    <button
                                        className="nav-arrow nav-arrow-right"
                                        onClick={goToNext}
                                        title="Next Image"
                                    >
                                        <IoChevronForward size={20} />
                                    </button>
                                </>
                            )}
                        </div>
                    </Col>

                    {/* Right Side - Alerts */}
                    <Col xl={4} lg={5} md={12} sm={12}>
                        <div style={{
                            borderRadius: "12px",
                            height: '355px'
                        }}>
                            <CardBody style={{ height: '355px', padding: '0' }}>
                                {/* Alerts List */}
                                {loading ? (
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "355px",
                                        color: "#9CA3AF"
                                    }}>
                                        Loading alerts...
                                    </div>
                                ) : (
                                    <div
                                        className="alerts-scroll-container"
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "12px",
                                            height: '355px',
                                            overflowY: 'auto',
                                            padding: '16px',
                                            scrollbarWidth: 'thin',
                                            scrollbarColor: '#CBD5E0 #F7FAFC'
                                        }}
                                    >
                                        {alerts.length > 0 ? alerts.map((alert, index) => (
                                            <div
                                                key={alert.id}
                                                className="alert-card"
                                                style={{
                                                    backgroundColor: currentImageIndex === index ? "#F0F9FF" : "#FAFAFA",
                                                    borderRadius: "8px",
                                                    borderLeft: `4px solid ${alert.borderColor}`,
                                                    padding: "16px",
                                                    position: "relative",
                                                    borderTop: "1px solid #E4E4E7",
                                                    borderRight: "1px solid #E4E4E7",
                                                    borderBottom: "1px solid #E4E4E7",
                                                    height: '110px',
                                                    cursor: alert.annotated_url || alert.unannotated_url ? 'pointer' : 'default',
                                                    transition: 'all 0.2s ease',
                                                    transform: currentImageIndex === index ? 'scale(1.02)' : 'scale(1)',
                                                    boxShadow: currentImageIndex === index ? '0 4px 12px rgba(0,0,0,0.1)' : 'none'
                                                }}
                                                onClick={() => handleAlertClick(alert, index)}
                                                onMouseEnter={(e) => {
                                                    if (alert.annotated_url || alert.unannotated_url) {
                                                        e.currentTarget.style.transform = currentImageIndex === index ? 'scale(1.02)' : 'translateY(-2px)';
                                                    }
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = currentImageIndex === index ? 'scale(1.02)' : 'translateY(0)';
                                                }}
                                            >
                                                <div className="d-flex justify-content-between align-items-start">
                                                    <div style={{ flex: 1, minWidth: 0, paddingRight: "8px" }}>
                                                        {/* Title */}
                                                        <h3 className="alert-title" style={{
                                                            fontSize: "16px",
                                                            fontWeight: "600",
                                                            color: "#111827",
                                                            margin: "0 0 4px 0",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap"
                                                        }}>
                                                            {alert.title}
                                                        </h3>
                                                        {/* Details */}
                                                        <div className="alert-details" style={{
                                                            fontSize: "13px",
                                                            color: "#9CA3AF",
                                                            lineHeight: "1.4"
                                                        }}>
                                                            <div style={{
                                                                marginBottom: "2px",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap"
                                                            }}>{alert.area}</div>
                                                            <div style={{
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap"
                                                            }}>{alert.camera}</div>
                                                        </div>
                                                    </div>

                                                    {/* Badge and Time */}
                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "flex-end",
                                                        flexShrink: 0,
                                                        minWidth: "80px"
                                                    }}>
                                                        <div className="alert-badge" style={{
                                                            backgroundColor: alert.badgeColor,
                                                            color: "white",
                                                            padding: "4px 8px",
                                                            borderRadius: "12px",
                                                            fontSize: "10px",
                                                            fontWeight: "500",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "4px",
                                                            marginBottom: "4px",
                                                            whiteSpace: "nowrap"
                                                        }}>
                                                            <IoTimeOutline size={10} />
                                                            {alert.badgeText}
                                                        </div>
                                                        <div className="alert-time" style={{
                                                            fontSize: "11px",
                                                            color: "#9CA3AF",
                                                            fontWeight: "500",
                                                            textAlign: "right",
                                                            lineHeight: "1.2"
                                                        }}>
                                                            {alert.time}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )) : (
                                            <div style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                height: "100%",
                                                color: "#9CA3AF",
                                                textAlign: "center"
                                            }}>
                                                No alerts found for this week
                                            </div>
                                        )}
                                    </div>
                                )}
                            </CardBody>
                        </div>
                    </Col>
                </Row>
            </Container>

            {/* Image Zoom Modal */}
            {showZoomModal && (
                <ImageZoom
                    photo={selectedImage}
                    setIsOpen={setShowZoomModal}
                    setShowModal={setShowZoomModal}
                    imageData={zoomImageData}
                    cameraTable={false}
                />
            )}
        </>
    );
};

export default HelmetModule;